import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconEraserLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.98 18h3.962a.73.73 0 0 1 .535.215.726.726 0 0 1 .215.535.726.726 0 0 1-.215.535.726.726 0 0 1-.535.215h-5.461l1.5-1.5ZM5.03 19.5a.903.903 0 0 1-.648-.271L2.886 17.73a1.788 1.788 0 0 1-.54-1.281 1.782 1.782 0 0 1 .515-1.306L13.437 4.167a1.68 1.68 0 0 1 1.273-.547c.497.003.921.18 1.273.532l4.532 4.533c.352.35.529.78.532 1.285.003.506-.17.934-.522 1.286l-7.773 7.973a.893.893 0 0 1-.658.271H5.031Zm6.812-1.5 7.629-7.829c.051-.051.077-.125.077-.221s-.026-.17-.077-.221l-4.517-4.517a.293.293 0 0 0-.216-.077.275.275 0 0 0-.217.086L3.914 16.18a.327.327 0 0 0-.077.226c0 .093.025.165.077.216L5.292 18h6.55Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEraserLine;
